<template>
    <div id="app" class="lang0">
        <div id="nav-menu">
            <router-link to="/newsroom">新闻</router-link>
            <router-link to="/blog">推送信息</router-link>
            <router-link to="/frontpage">首页板块</router-link>
            <router-link to="/products">产品页</router-link>
            <router-link to="/categories">分类</router-link>
            <router-link to="/gallery">素材库</router-link>
            <router-link to="/sentinel">后台</router-link>
            <router-link v-if="!loggedIn" to="/login">登陆</router-link>
            <a v-if="loggedIn" href="#" @click="logout">登出</a>
        </div>
        <div id="saving-mask"
             :class="{saving}"
             v-show="saving || savingError">
            <div>
                <span v-show="saving">保存中，剩余{{saving}}项</span>
                <span v-show="savingError">{{savingError}}</span>
            </div>
        </div>
        <router-view id="panel"
                     :class="{ saving }"
                     @set-saving="setSaving"
                     @set-login="setLogin"
                     @saving-failed="savingFailed"/>
    </div>
</template>

<script>
	import auth from "./services/AuthService";

	export default {
		name: "App",
		data() {
			return {
				saving: 0,
                savingError: "",
                loggedIn: false
			};
		},
		async mounted() {
			let pathname = window.location.pathname;
			if (pathname === "/sentinel") {
				return;
            }
			if (!auth.init()) {
				if (pathname !== "/login") {
					await this.$router.push("/login");
				}
			} else {
				this.loggedIn = true;
				if (pathname === "/" || pathname === "/login") {
					await this.$router.push("/newsroom");
				}
				if (!await auth.check()) {
					this.loggedIn = false;
					await this.$router.push("/login");
				}
			}
		},
		methods: {
			setSaving(x) {
				this.saving = x;
			},
            setLogin(loggedIn) {
				this.loggedIn = loggedIn
            },
            savingFailed() {
                this.savingError = "（部分或全部保存失败）"
            },
            logout() {
				if (confirm("确定登出吗？")) {
					auth.logout();
                }
            }
		}
	}
</script>

<style lang="scss">
    html, body {
        margin: 0;
        padding: 0;
        background-color: $p-bg;
        height: 100%;
    }

    #app {
        font-family: $sans-serif;
        display: flex;
        flex-direction: row;
        height: 100%;
        width: 100vw;
    }

    #nav-menu {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100px;
        min-width: 100px;
        padding-left: 16px;
        height: 100%;
        background-color: $p-fg;
        color: $p-bg;
    }

    #panel {
        position: relative;
        flex: 1;
    }

    a {
        color: $p-bg;
        padding: 4px;
        font-family: $serif;
    }

    a.router-link-active {
        font-weight: bold;
        background-color: $p-bg;
        color: $p-fg;
    }

    .saving {
        pointer-events: none;
    }

    #saving-mask {
        position: absolute;
        top: 0;
        left: 116px;
        right: 0;
        bottom: 0;
        z-index: 1;
    }

    #saving-mask.saving {
        background-color: transparentize($p-bg, 0.8);
    }

    #saving-mask:not(.saving) {
        pointer-events: none;
    }

    #saving-mask > div {
        background-color: $p-fg;
        color: $p-bg;
        padding: 8px;
        margin: 16px;
        display: inline-block;
    }
</style>